import * as React from 'react';

import { Form, Formik } from 'formik';

import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Paper, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import CloudUpload from '@mui/icons-material/CloudUpload';
import useAuth from '../../context/AuthProvider';
import { CustomerPolicyModel_VS } from '../../models/CustomerPolicyModel';
import CircularProgress from '@mui/material/CircularProgress';
import { apiClient } from '../../helper/api';

var formData = new FormData();

export interface ReqDocuments {
    documentName?: string,
    modelId?: number
    isRequired?: boolean
}
export function GenericStyledDropZone(props: any & ReqDocuments) {
    const {
        getRootProps,
        getInputProps,
        acceptedFiles,
        isFocused,
        isDragAccept,
        isDragReject,
    } = useDropzone({
        maxFiles: 1,
        accept: { 'application/pdf': ['.pdf'], 'image/*': [], 'application/msg': ['.msg'] },
        onDrop: (files) => {
            formData.delete(props.doc.documentName);
            formData.append(props.doc.modelId + "__" + props.doc.documentName, files[0]);
        },
    });

    const isDragOver = isFocused || isDragAccept;

    const files = acceptedFiles.map((file) => (
        <Typography key={file.name} variant="body2" sx={{ color: 'text.primary', fontWeight: 500 }}>
            {file.name.length > 35 ? `${file.name.substring(0, 35)}…` : file.name}
        </Typography>
    ));

    return (
        <Box sx={{ width: '100%' }}>
            <Paper
                variant="outlined"
                {...getRootProps()}
                sx={{
                    p: 2.5,
                    borderRadius: 2,
                    borderStyle: 'dashed',
                    borderWidth: 2,
                    cursor: 'pointer',
                    outline: 'none',
                    transition: 'all 0.25s ease',
                    borderColor: isDragReject ? '#ef5350' : isDragOver ? '#1976d2' : 'rgba(13, 74, 99, 0.25)',
                    backgroundColor: isDragReject
                        ? 'rgba(211, 47, 47, 0.06)'
                        : isDragOver
                          ? 'rgba(25, 118, 210, 0.08)'
                          : 'grey.50',
                    boxShadow: isDragOver && !isDragReject ? '0 8px 24px rgba(25, 118, 210, 0.15)' : 'none',
                    transform: isDragOver && !isDragReject ? 'scale(1.01)' : 'none',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                    gap: 1,
                }}
            >
                <input {...getInputProps()} name={props.doc.documentName} />
                <CloudUpload sx={{ fontSize: 40, color: isDragReject ? 'error.main' : 'primary.main', opacity: 0.85 }} />
                <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'text.primary' }}>
                    {props.doc.documentName}
                    {props.doc.isRequired ? (
                        <Typography component="span" sx={{ color: 'error.main', ml: 0.5 }}>
                            *
                        </Typography>
                    ) : null}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Click to browse or drag and drop (PDF, image, or .msg)
                </Typography>
            </Paper>
            <Box sx={{ mt: 1, minHeight: 24 }}>{files}</Box>
        </Box>
    );
}

interface props {
    open: boolean
    handleClose: () => void
    custPolicyID: string
}


export const AddEditResubmitSingleDocument: React.FC<props> = ({ open, handleClose, custPolicyID }) => {
    const Reqdocuments: ReqDocuments = {
        documentName: "",
        modelId: 0,
        isRequired: false,

    }

    const [RequireedDocuments, setRequiredDocuments] = useState([Reqdocuments]);
    const [IsSingleDocument, setIsSingleDocument] = useState(true);


    function CheckIsSingleDocument() {
        setloading(true);
        apiClient(`/MasterPolicyType/checkIsSingleDocument?customerPolicyId=${custPolicyID}`,
            {
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            })
            .then((res) => {
                if (!res) return

                // Do something with the response

                setIsSingleDocument(res.data);

                if (!res.data) {
                    fetchRequiredDocumentName();
                } else {
                    setRequiredDocuments([{ documentName: "Single Document", modelId: 1 }]);
                }

            }).finally(() => {
                setloading(false);
            });
    }


    function fetchRequiredDocumentName() {
        setloading(true);
        apiClient(`/MasterPolicyType/getRequiredDocuments?custPolicyId=${custPolicyID}`,
            {
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            })
            .then((res) => {
                if (!res) return
                console.log(res);
                // Do something with the response

                setRequiredDocuments(res.data);

                setloading(false);

            }).finally(() => {
                setloading(false);
            });
    }


    // let ID: number = 0;
    // const [PolicyTypeId, setPolicyTypeId] = useState(ID);

    const initialValues: { transactionTypeId: number, UserId: number } = { transactionTypeId: 0, UserId: 0 }
    const [loading, setloading] = useState(false);
    const { user } = useAuth();
    const token = user?.token;

    useEffect(() => {
        if (!open || !custPolicyID || custPolicyID === '0') return;
        CheckIsSingleDocument();
    // CheckIsSingleDocument loads required docs for the current custPolicyID when the dialog opens.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, custPolicyID])
    const sectionTitleSx = {
        color: 'text.secondary',
        fontWeight: 600,
        letterSpacing: '0.08em',
        display: 'block',
        mb: 1,
    };
    const paperSectionSx = { p: 2, borderRadius: 2, borderColor: 'divider', backgroundColor: 'grey.50' };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth="lg"
            PaperProps={{
                sx: {
                    width: '90%',
                    maxWidth: 960,
                    minHeight: '40vh',
                    maxHeight: '90vh',
                    borderRadius: 2,
                    boxShadow: '0 24px 48px rgba(0,0,0,0.12)',
                    overflow: 'hidden',
                },
            }}
            sx={{ '& .MuiDialog-paper': { overflow: 'hidden' }, "& .MuiDialogContent-root": { minHeight: '30vh' } }}
        >
            {loading && <LinearProgress sx={{ flexShrink: 0 }} />}
            <DialogTitle
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 1,
                    py: 2,
                    px: 3,
                    background: 'linear-gradient(135deg, #0d4a63 0%, #15607a 100%)',
                    color: '#fff',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <DescriptionOutlinedIcon sx={{ fontSize: 28, opacity: 0.95 }} />
                    <Typography component="span" variant="h6" sx={{ fontWeight: 600, letterSpacing: '0.02em' }}>
                        Upload Documents
                    </Typography>
                </Box>
                <IconButton
                    onClick={handleClose}
                    sx={{
                        color: 'rgba(255,255,255,0.9)',
                        '&:hover': { color: '#fff', backgroundColor: 'rgba(255,255,255,0.12)' },
                    }}
                    aria-label="Close dialog"
                >
                    <CloseOutlinedIcon />
                </IconButton>
            </DialogTitle>
            <React.Fragment>
                    <Formik initialValues={initialValues}
                        validateOnChange={true}
                        validationSchema={CustomerPolicyModel_VS}

                        onSubmit={(data, { setSubmitting }) => {
                            let count = 0
                            formData.forEach(element => {
                                count = count + 1;
                            });
                            if (count < 1) {
                                alert("select a document");
                                setSubmitting(false);
                                return;

                            } else {
                                setloading(true);
                                formData.append('transactionTypeId', data.transactionTypeId.toString() ?? "");
                                let ID = custPolicyID?.toString() ?? "";
                                formData.append('CustomerPolicyId', ID);

                                if (IsSingleDocument) {
                                    apiClient(`/CustomerPolicy/CorrectedDocumentSubmission/`,
                                        {
                                            method: 'POST',
                                            headers: new Headers({
                                                // 'Content-Type': 'application/json',
                                                'Authorization': `Bearer ${token}`,
                                            }),
                                            body: formData  // <-- Post parameters

                                        })
                                        .then((res) => {
                                            if (!res) return

                                            // Do something with the response

                                            // console.log(res);
                                            // if (res.resp == 200) {
                                            //     handleClose();
                                            // } else {
                                            //     alert(res.data);
                                            // }

                                        }).finally(() => {
                                            setSubmitting(false);
                                            formData = new FormData();
                                            setloading(true);
                                            handleClose();
                                        });

                                } else {
                                    apiClient(`/CustomerPolicy/CorrectedDocumentSubmission/`,
                                        {
                                            method: 'POST',
                                            headers: new Headers({
                                                // 'Content-Type': 'application/json',
                                                'Authorization': `Bearer ${token}`,
                                            }),
                                            body: formData  // <-- Post parameters

                                        })
                                        .then((res) => {
                                            if (!res) return

                                            // Do something with the response

                                            // if (res.resp == 200) {
                                            //     handleClose();
                                            // } else {
                                            //     alert(res.data);
                                            // }

                                        }).finally(() => {
                                            setSubmitting(false);
                                            alert("There was an error saving the Document");
                                            formData = new FormData();
                                            setloading(true);
                                            handleClose();
                                        });

                                }


                            }
                        }
                        } >
                        {({ isSubmitting }) =>
                        (
                            <Form>
                                <DialogContent sx={{ px: 3, py: 2, overflow: 'auto', backgroundColor: 'grey.50' }}>
                                    <Typography variant="overline" sx={sectionTitleSx}>
                                        Required files
                                    </Typography>
                                    <Paper variant="outlined" sx={{ ...paperSectionSx, mb: 2 }}>
                                        {RequireedDocuments && RequireedDocuments.length > 0 ? (
                                            <Box
                                                sx={{
                                                    display: 'grid',
                                                    // gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
                                                    // gap: 2,
                                                }}
                                            >
                                                {RequireedDocuments.map((file, index) => (
                                                    <Paper key={`${file.modelId}_${file.documentName}_${index}`} sx={{boxShadow: 'none', backgroundColor: 'transparent'}}>
                                                        <GenericStyledDropZone doc={file} />
                                                    </Paper>
                                                ))}
                                            </Box>
                                        ) : (
                                            <Typography color="text.secondary">Mapping not found for this transaction</Typography>
                                        )}
                                    </Paper>
                                </DialogContent>
                                <DialogActions
                                    sx={{
                                        borderTop: 1,
                                        borderColor: 'divider',
                                        backgroundColor: 'grey.100',
                                        px: 3,
                                        py: 2,
                                        gap: 1.5,
                                        flexWrap: 'wrap',
                                    }}
                                >
                                    <Button
                                        type="button"
                                        variant="outlined"
                                        startIcon={<CloseOutlinedIcon />}
                                        onClick={handleClose}
                                        sx={{ fontWeight: 600, textTransform: 'none' }}
                                    >
                                        Cancel
                                    </Button>
                                    {RequireedDocuments && RequireedDocuments.length > 0 ? (
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            disabled={isSubmitting}
                                            startIcon={<CloudUploadOutlinedIcon />}
                                            sx={{
                                                fontWeight: 600,
                                                textTransform: 'none',
                                                backgroundColor: '#2099d2',
                                                '&:hover': { backgroundColor: '#1a7ba8' },
                                            }}
                                        >
                                            Upload
                                        </Button>
                                    ) : null}
                                    {loading && <CircularProgress size={28} sx={{ ml: 1 }} />}
                                </DialogActions>
                            </Form>

                        )}
                    </Formik>
                </React.Fragment>
        </Dialog>
    );
}

